<template>
  <div class="account__item">
    <div class="account__content">
      <h2 class="title--l">{{ getUiString(['my_account', 'contact_overview', 'title']) }}</h2>
      <div class="text">
        {{ getUiString(['my_account', 'contact_overview', 'text']) }}
        </div>
      <div class="account__row">
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_name']) }}</div>
          <div class="value">{{ fullName }}</div>
        </div>
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_street_housenumber']) }}</div>
          <div class="value">{{ account.StreetName }} {{ account.HouseNumber }}{{ account.HouseNumberExtension }}</div>
        </div>
      </div>
      <div class="account__row">
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_zipcode_city']) }}</div>
          <div class="value">{{ account.PostalCode }} {{ account.City }}</div>
        </div>
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_country']) }}</div>
          <div class="value">{{ selectedCountry.Name }}</div>
        </div>
      </div>
      <div class="account__row">
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_phone_number']) }}</div>
          <div class="value">{{ account.PhoneNumber }}</div>
        </div>
        <div class="account__cell">
          <div class="label">{{ getUiString(['my_account', 'contact_overview', 'label_emailaddress']) }}</div>
          <div class="value">{{ account.EMailAddress }}</div>
        </div>
      </div>
      <a class="link link--edit" href="#" @click.prevent="$emit('edit-account')">
        <lennoc-icon image="edit"/>
        <span>{{ getUiString(['my_account', 'contact_info', 'edit_button_text']) }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AccountData',
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      fullName: 'account/getAccountFullName',
      account: 'account/shadowAccount',
      countries: 'getCountries'
    }),
    selectedCountry () {
      const selCountry = this.countries.filter(el => el.Code === this.account.CountryCode)
      if (selCountry.length) {
        return selCountry[0] || {}
      }
      return {}
    }
  }
}
</script>
